import styled from 'styled-components';

export const PlansBox = styled.div`
  max-width: 900px;
  margin: 64px auto 0;
  padding: 32px;
  border: 1px solid #e3eaf5;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(15, 33, 55, 0.08);

  h3.compare {
    margin: 0 0 20px;
    color: #0f2137;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    text-align: center;
  }

  @media (max-width: 767px) {
    padding: 24px 16px;
    margin-top: 40px;
  }
`;

export const TableScroll = styled.div`
  width: 100%;
`;

export const PlansTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  line-height: 1.5;

  th,
  td {
    padding: 12px 14px;
    border-bottom: 1px solid #e3eaf5;
    text-align: left;
    vertical-align: top;
  }

  thead th {
    background: #f7faff;
    color: #0f2137;
    font-weight: 700;
  }

  tbody th {
    color: #0f2137;
    font-weight: 500;
  }

  td {
    color: #343d48;
  }

  @media (max-width: 767px) {
    thead {
      display: none;
    }

    tr,
    th,
    td {
      display: block;
    }

    tr {
      padding: 10px 0;
      border-bottom: 1px solid #e3eaf5;
    }

    th,
    td {
      padding: 4px 6px;
      border-bottom: 0;
    }

    td::before {
      content: attr(data-label) ': ';
      color: #46679f;
      font-weight: 700;
    }
  }
`;

export const Terms = styled.div`
  margin-top: 24px;

  p {
    margin: 0 0 10px;
    color: #343d48;
    font-size: 15px;
    line-height: 1.7;
  }
`;

export const Closing = styled.div`
  margin-top: 16px;

  h3 {
    margin: 0 0 8px;
    color: #0f2137;
    font-size: 17px;
    font-weight: 600;
  }

  ul {
    margin: 0 0 12px;
    padding-left: 20px;
    list-style: disc;
    color: #343d48;
    font-size: 15px;
    line-height: 1.7;
  }

  a {
    color: #335d9f;
    font-weight: 600;
  }
`;
